<template>
<div>克隆监控面板</div>
</template>

<script>
export default {
  name: 'cloneMonitorDashboard',
}
</script>

<style scoped>

</style>
